module.exports = __webpack_public_path__ + "static/media/create-and-share.c15375d1.jpg";